import { service } from '..';

const assignmentType = {
  add: 0,
  remove: 1,
  update: 2,
  keep: 3
};

function process( assignmentType, configuration, changes = [] ) {
  const assignments = changes.map( change => ( {
    assignmentType,
    key: change.property || change.key || change.Key,
    value: change.value || change.Value
  } ) );
  return service( 'configure' ).post( { configuration, assignments } );
}

export const configuratorService = {
  assignValue( materialConfigurationData, property, value ) {
    return process( assignmentType.add, materialConfigurationData, [{property, value}] );
  },
  removeValue( materialConfigurationData, property, value ) {
    return process( assignmentType.remove, materialConfigurationData, [{property, value}] );
  },
  fromConfigured( materialConfigurationData, assignments ) {
    return process( assignmentType.update, materialConfigurationData, assignments );
  },
  resetGroup( materialConfigurationData, group ) {
    let variablesToRemove = group.variables
      .filter( variable => variable.assignedValue && variable.isUserAssignment )
      .reduce( ( current, item ) => {
        current[item.fullyQualifiedName] = true;
        current[item.name] = true;
        return current;
      }, {} );
      // easiest way to remove a groups variables is by removing the existing assignments
    return process( 
      assignmentType.remove, 
      { 
        ...materialConfigurationData, 
        existingAssignments: materialConfigurationData.existingAssignments.filter( assignment => !variablesToRemove[assignment.key] )
      }
    );
  },
  fromTemplate( product, modelToLoad, filterGroups, assignments, additionalVariants ) {
    return service( 'template' ).post( {
      name: product.name,
      modelToLoad,
      filterGroups,
      assignments,
      additionalVariants
    } );
  },
  fromComplexTemplate( data ) {
    return configuratorService.fromTemplate( data.product, data.modelToLoad );
  }
};